document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.section-pdp-trio');
  if (!section) return;

  section.addEventListener('click', async (event) => {
    const btn = event.target.closest('.section-pdp-trio__share');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const { shareQuote, shareUrl } = btn.dataset;
    if (!shareQuote) return;

    const pdpUrl = shareUrl || window.location.href;

    const shareData = {
      text: shareQuote,
      url: pdpUrl,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Share failed:', error);
        }
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(`${shareQuote} — ${pdpUrl}`);
      btn.classList.add('is-copied');

      const timeout = setTimeout(() => {
        btn.classList.remove('is-copied');
      }, 2000);

      btn.addEventListener(
        'pointerleave',
        () => {
          clearTimeout(timeout);
          btn.classList.remove('is-copied');
        },
        { once: true }
      );
    } catch (error) {
      console.error('Copy failed:', error);
    }
  });
});
